import React from 'react';
import { StarFilled } from '@ant-design/icons';
import { Box, Typography } from '@mui/material';
import moment from 'moment';

const StarCell: React.FC<{
  hasEvent: boolean;
  time: moment.Moment;
  type: 'day' | 'month';
}> = ({ hasEvent, time, type }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
        height: '100%',
      }}
    >
      <Typography>
        {type === 'day' && time.format('D')}
        {type === 'month' && time.format('M')}
      </Typography>
      {hasEvent && (
        <Box
          sx={{
            flexGrow: 1,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <StarFilled
            style={{
              color: 'rgb(249, 195, 32)',
              marginTop: '10px',
              fontSize: '2vw',
            }}
          />
        </Box>
      )}
    </Box>
  );
};

export default StarCell;
